var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33354 2.70009C6.04737 2.86868 4.86672 3.50024 4.01262 4.47654C3.15852 5.45285 2.6895 6.70696 2.69338 8.00413C2.69726 9.3013 3.17376 10.5526 4.03369 11.5238C4.89362 12.495 6.07802 13.1194 7.36517 13.2803C8.65233 13.4412 9.95401 13.1275 11.0265 12.3979C12.0991 11.6683 12.8689 10.5728 13.192 9.31646C13.515 8.06016 13.3692 6.72918 12.7817 5.57267C12.1942 4.41617 11.2053 3.51342 10.0002 3.03342M13.3335 2.70009L10.0002 2.70009L10.0002 6.03342",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.c3ee1aed1eb67bfd1e4d88a8a7fd854b.svg";
export { ForwardRef as ReactComponent };